module.exports = __webpack_public_path__ + "static/media/utu_blue.308191df.svg";